"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInfo = exports.IbanPaymentMethod = exports.PaymentMethod = void 0;
const validator_1 = require("@leavy/validator");
const PaymentMethodType_1 = require("./PaymentMethodType");
const ddd_1 = require("../../infrastructure/ddd");
const utils_1 = require("@leavy/utils");
class PaymentMethod extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
exports.PaymentMethod = PaymentMethod;
class IbanPaymentMethod extends PaymentMethod {
    constructor(data) {
        super();
        this.type = PaymentMethodType_1.PaymentMethodType.IBAN;
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.type) && utils_1.Guard.Enum.isEnumMember(PaymentMethodType_1.PaymentMethodType)(this.type)
            && utils_1.Guard.isNotNullish(this.iban) && utils_1.Guard.String.isNotEmpty(this.iban)
            && utils_1.Guard.isNotNullish(this.bic) && utils_1.Guard.String.isNotEmpty(this.bic));
    }
    toPlain() {
        return { ...this };
    }
}
exports.IbanPaymentMethod = IbanPaymentMethod;
class PaymentInfo extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.methods = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.methods)
            && this.methods.length > 0
            && this.methods.every(x => x.isComplete()));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => PaymentMethod, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "type",
            subTypes: [
                { name: PaymentMethodType_1.PaymentMethodType.IBAN, value: IbanPaymentMethod },
            ],
        },
    }),
    __metadata("design:type", Array)
], PaymentInfo.prototype, "methods", void 0);
exports.PaymentInfo = PaymentInfo;
//# sourceMappingURL=PaymentInfo.js.map